<template lang="pug">
footer.row.text-white
    .col-1.col-sm-2.order-1
    .col-10.col-md-4.order-2.order-sm-5
        .row.mt-5.mb-sm-5.text-center.d-flex.justify-content-around
            .col-12
                h6.text-uppercase.mb-4 Contáctanos
            .col-12
                a.text-white( href='mailto:mirna@ortografiacerebral.com')
                    i.fa.fa-envelope
                    h6.font-weight-light.d-inline-block.ml-3 mirna@ortografiacerebral.com
            .col-12
                a.text-white( href='tel:0445530803890')
                    i.fa.fa-phone
                    h6.font-weight-light.d-inline-block.ml-3 044 (55) 3080 3890
    .col-1.d-sm-none.order-3
    .col-1.d-sm-none.order-4
    .col-10.col-md-4.mt-5.mb-3.text-left.text-sm-right.order-5.order-sm-2
        .col-12.text-center.text-sm-right
            h6.font-weight-light.d-none.d-sm-inline-block.mr-3 Ortografía Cerebral
            a.text-white( href='https://www.facebook.com/ortografiacerebral/')
                i.fab.fa-facebook-square.fa-2x.d-sm-inline-block
            a.text-white( href='https://www.youtube.com/channel/UCR15XQ2ZKBT9rtb6LWXmqeA')
                i.fab.fa-youtube-square.fa-2x.d-sm-inline-block.ml-3
            a.text-white( href='https://www.instagram.com/ortografia_cerebral/')
                i.fab.fa-instagram.fa-2x.d-sm-inline-block.ml-3
            a.text-white( href='https://twitter.com/ocerebral')
                i.fab.fa-twitter-square.fa-2x.d-sm-inline-block.ml-3
            h6.font-weight-lightd-sm-none.d-sm-none.mt-2 Ortografía Cerebral
        .col-12.mt-5.mt-sm-3
            a.text-white( href='https://www.facebook.com/mirnajuraidini/')
                i.fab.fa-facebook-square.d-sm-none.ml-5.mr-3
                h6.font-weight-light.d-inline-block.mr-3 Dra Mirna Juraidini
                i.fab.fa-facebook-square.d-none.d-sm-inline-block
        .col-12
            a.text-white( href='https://www.facebook.com/mujeresadas.sinh/')
                i.fab.fa-facebook-square.d-sm-none.ml-5.mr-3
                h6.font-weight-light.d-inline-block.mr-3 Mujeres Adas sin "H"
                i.fab.fa-facebook-square.d-none.d-sm-inline-block
        .col-12
            a.text-white( href='https://www.facebook.com/ortoymas/')
                i.fab.fa-facebook-square.d-sm-none.ml-5.mr-3
                h6.font-weight-light.d-inline-block.mr-3 Fundación 50 y más
                i.fab.fa-facebook-square.d-none.d-sm-inline-block
    .col-1.col-sm-2.order-6
    // right margin
    .col-12.rights.text-center.mb-2.order-7
        span &copy; {{ year }} Ortografía Cerebral - Todos los derechos reservados
        p Desarrollado por Code Inc         
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue